import { SingleSectionPageLayout } from "../../../../common/components/common/SingleSectionPageLayout";
import { PageMode } from "../../../../common/types";
import { UserWizardContents } from "./components/UserWizardContents";
import { useAppContext } from "../../../../AppContext";

interface IUserWizardProps {
  pageMode: PageMode;
}

export const UserWizard = ({ pageMode }: IUserWizardProps) => {
  const { isDesktopOrTablet } = useAppContext();

  const pageTitle = `${
    pageMode === "add" ? "Добавяне" : "Редактиране"
  } на потребител`;

  return (
    <SingleSectionPageLayout
      title={pageTitle}
      children={<UserWizardContents pageMode={pageMode} />}
      maxHeight={isDesktopOrTablet ? "80%" : "90%"}
      height={"auto"}
    />
  );
};
